export default __webpack_public_path__ + "a7bb3b6370ca51603460265828c3fabd.svg";